function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".switch-icon{fill:url(#switch);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "switch",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 0.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#FAB800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F66614"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M21.394,9.394a15.015,15.015,0,0,1,21.212,0,1,1,0,1,0,1.415-1.415,17.02,17.02,0,0,0-24.042,0,1,1,0,1,0,1.415,1.415Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M40.485,12.515a1,1,0,0,0,.707-1.707,13.011,13.011,0,0,0-18.384,0,1,1,0,1,0,1.414,1.414,11.012,11.012,0,0,1,15.556,0A1,1,0,0,0,40.485,12.515Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M37.657,15.343a1,1,0,0,0,.707-1.707,9.01,9.01,0,0,0-12.728,0A1,1,0,0,0,27.05,15.05a7.009,7.009,0,0,1,9.9,0A.993.993,0,0,0,37.657,15.343Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M29,19a3,3,0,1,0,3-3A3,3,0,0,0,29,19Zm4,0a1,1,0,1,1-1-1A1,1,0,0,1,33,19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M59,25V11a1,1,0,0,0-1-1H55.816a3,3,0,1,0,0,2H57V25H52V19a1,1,0,0,0-1-1H47.816a3,3,0,1,0,0,2H50v5H14V20h2.184a3,3,0,1,0,0-2H13a1,1,0,0,0-1,1v6H7V12H8.184a3,3,0,1,0,0-2H6a1,1,0,0,0-1,1V25a3,3,0,0,0-3,3V58a3,3,0,0,0,3,3H59a3,3,0,0,0,3-3V28A3,3,0,0,0,59,25ZM53,12a1,1,0,1,1,1-1A1,1,0,0,1,53,12Zm-8,8a1,1,0,1,1,1-1A1,1,0,0,1,45,20ZM19,18a1,1,0,1,1-1,1A1,1,0,0,1,19,18Zm-8-8a1,1,0,1,1-1,1A1,1,0,0,1,11,10ZM60,58a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V28a1,1,0,0,1,1-1H59a1,1,0,0,1,1,1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M30,29H6a1,1,0,0,0-1,1V56a1,1,0,0,0,1,1H30a1,1,0,0,0,1-1V30A1,1,0,0,0,30,29ZM29,55H7V31H29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M58,29H34a1,1,0,0,0-1,1V56a1,1,0,0,0,1,1H58a1,1,0,0,0,1-1V30A1,1,0,0,0,58,29ZM57,55H35V31H57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M14,54h8a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1V53A1,1,0,0,0,14,54Zm1-2V48h6v4Zm6-18V46H15V34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "switch-icon",
  d: "M42,54h8a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H42a1,1,0,0,0-1,1V53A1,1,0,0,0,42,54Zm1-2V40h6V52Zm6-18v4H43V34Z"
}));

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.d2e35c60.svg";
export { ForwardRef as ReactComponent };